import Api from 'modules/common/api/Api';
import Auth from 'modules/common/auth/Auth';
import ErrorScreen from 'modules/common/errorScreen/ErrorScreen';
import Language from 'modules/common/language/Language';

const modules = {
	api: Api,
	auth: Auth,
	errorScreen: ErrorScreen,
	language: Language,
};

const req = require.context("./init/", true, /^\..*\/([^/]*)\/\1.[jt]s$/i);

// Using the first-character-lowercase name of the js-file as module name
req.keys().forEach(key => {
	let match = key.match(/\/([^/]*)\.[jt]s$/);
	let name = match[1].charAt(0).toLowerCase() + match[1].slice(1);
	if (modules[name]) {
		throw new Error(`Duplicate module: ${key}`);
	}
	modules[name] = req(key).default;
});

export default modules;
